(function(){
    var nominatim = {
        selectedAddress: {},
        availableAddresses: [],
        addressFields: {},
        addressesListSelector: '#nz-post-addresses-list',
        clearAddressesList: function(addresses){
            this.hideAddressList();
            $(this.addressesListSelector).children().remove();
        },
        displayAddresses: function(addresses) {
            this.clearAddressesList();
            for (var index = 0; index < addresses.length; index++) {
                var address = addresses[index];
                var properties = address.properties
                var id = properties.osm_id
                var displayName = ''
                if (properties.housenumber) {
                    displayName += properties.housenumber
                }
                if (properties.street) {
                    if (displayName !== '') {
                        displayName += ' '
                    }
                    displayName += properties.street
                } else if (properties.name) {
                    if (displayName !== '') {
                        displayName += ' '
                    }
                    displayName += properties.name
                }
                if (properties.district) {
                    if (displayName !== '') {
                        displayName += ', '
                    }
                    displayName += properties.district
                }
                if (properties.city) {
                    if (displayName !== '') {
                        displayName += ', '
                    }
                    displayName += properties.city
                }
                if (properties.postcode) {
                    if (displayName !== '') {
                        displayName += ', '
                    }
                    displayName += properties.postcode
                }
                if (properties.state) {
                    if (displayName !== '') {
                        displayName += ', '
                    }
                    displayName += properties.state
                }
                if (properties.country) {
                    if (displayName !== '') {
                        displayName += ', '
                    }
                    displayName += properties.country
                }
                var currentAddress = {
                    id: id,
                    displayName: displayName
                };
                var formattedAddress = this.getHTMLFormattedAddress(currentAddress, true);

                // add the addresses list
                $(this.addressesListSelector).append(formattedAddress);
            }
            this.showAddressList();
        },
        getHTMLFormattedAddress: function(address, collapsed){
            var html = '<li class="address" data-address-id="' + address.id + '"><span class="glyphicon map-marker glyphicon-map-marker"></span> <span class="address-details">' + address.displayName + '</span></li>';
            return html;
        },
        hideAddressList: function(){
            $(this.addressesListSelector).hide();
        },
        setClickHandler: function(callback) {
            $(this.addressesListSelector + ' li.address').click(function() {
                var addressId = $(this).data('addressId');
                callback(addressId);
            });
        },
        showAddressList: function(){
            $(this.addressesListSelector).show();
        }
    };
    window.nominatim = nominatim;
})();